/// Menu
import React, { Component, useContext, useEffect, useReducer, useState } from "react";
//import Metismenu from "metismenujs";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from 'react-bootstrap/Collapse';
import Button from 'react-bootstrap/Button';

/// Link
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { Logout } from "../../../store/actions/AuthActions";
import nbrApi from "../../../services/nbrApi";
import { hasDifferentRoleOrProperty } from "../../../services/common.utils";

import { getMenuList } from './Menu';
import {useScrollPosition} from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";

//import medal from "../../../images/medal.png";


// class MM extends Component {
// 	componentDidMount() {
// 		this.$el = this.el;
// 		this.mm = new Metismenu(this.$el);
// 	}
//   componentWillUnmount() {
//   }
//   render() {
//     return (
//       <div className="mm-wrapper">
//         <ul className="metismenu " ref={(el) => (this.el = el)}>
//           {this.props.children}
//         </ul>
//       </div>
//     );
//   }
// }

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active : "",
  activeSubmenu : "",
}

const SideBar = () => {
	const {
		iconHover,
		sidebarposition,
		headerposition,
		sidebarLayout,
	} = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [diffRoleProperty, setDiffRoleProperty] = useState(null);
  const [noMoreRole, setNoMoreRole] = useState(false);

  const selectedLoginData = useSelector(state => state.auth.loginData);
  const userData = useSelector(state => state.auth.userData);
  const userDataAll = JSON.parse(localStorage.getItem('userDetailsAll')) || {};

  let selectedDataFilter = userData?.filter(e =>
    e?.properties_id === parseInt(selectedLoginData?.properties_id) &&
    e?.roles_id === Number(selectedLoginData?.role_id)
  )?.[0];
  let selectedData = userDataAll?.user_info ? userDataAll?.user_info : selectedDataFilter;

  useEffect(() => {
    if (userDataAll?.user_info?.properties_roles_array?.length > 0) {
      let isResp = hasDifferentRoleOrProperty(userDataAll?.user_info?.properties_roles_array);
      setDiffRoleProperty(isResp);
    }
    if (userDataAll?.user_info?.properties_roles_array?.length === 1) {
      setNoMoreRole(true);
    } else {
      setNoMoreRole(false);
    }
  }, [userDataAll]);

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Yes, log me out!',
    }).then((result) => {
      if (result.isConfirmed) {
        let payload = {
          resources_id: selectedData?.resources_id
        };
        nbrApi.post('/logout', payload)
          .then(response => {
            if (response.status === 200) {
              localStorage.removeItem('canShowCleaningBtn');
              dispatch(Logout(navigate));
              Swal.fire({
                position: 'center',
                icon: 'success',
                title: `Logged out!`,
                text: 'You have been logged out successfully.',
                showConfirmButton: false,
                timer: 2000,
              });
            } else {
              Swal.fire({
                position: 'center',
                icon: 'error',
                title: `Error!`,
                text: 'Failed to log out. Please try again.',
                showConfirmButton: false,
                timer: 2000,
              });
            }
          })
          .catch(error => {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: `Error!`,
              text: 'Failed to log out. Please try again.',
              showConfirmButton: false,
              timer: 2000,
            });
          });
      }
    });
  };	

  // let handleheartBlast = document.querySelector('.heart');
  // function heartBlast(){
  //   return handleheartBlast.classList.toggle("heart-blast");
  // }

	useEffect(() => {
				
			
	}, []);
 //For scroll
 	const [hideOnScroll, setHideOnScroll] = useState(true)
	useScrollPosition(
		({ prevPos, currPos }) => {
		  const isShow = currPos.y > prevPos.y
		  if (isShow !== hideOnScroll) setHideOnScroll(isShow)
		},
		[hideOnScroll]
	)

	// Menu dropdown list 
	//const [active , setActive] = useState('');
	//const [activeSubmenu , setActiveSubmenu] = useState('');

 
  const handleMenuActive = status => {
		
    setState({active : status});
		
		if(state.active === status){
			
      setState({active : ""});
    }
   
	}
	const handleSubmenuActive = (status) => {
		
    setState({activeSubmenu : status})
		if(state.activeSubmenu === status){
      setState({activeSubmenu : ""})
			
		}
    
	}
	// Menu dropdown list End

  const closeSidebarOnNavigate = () => {
    if (typeof window !== 'undefined' && window.innerWidth <= 768) {
      document.querySelector("#main-wrapper")?.classList.remove("menu-toggle");
    }
  };

  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  /// Active menu
  // let deshBoard = [
  //     "",
  //     "dashboard-dark",
  //     "food-order",
  //     "favorite-menu",
  //     "message",
  //     "order-history",
  //     "notification",
  //     "bill",
  //     "setting",
  //     "task",
  //   ],
	// restro=[
	// 	"restaurant",
	// 	"menu",
	// 	"orders",
	// 	"customer-reviews",
	// 	"restro-setting",
	// ],
	// drivers=[
	// 	"deliver-main",
	// 	"deliver-order",
	// 	"feedback",
	// ],
  //   app = [
  //     "app-profile",
  //     "post-details",
  //     "app-calender",
  //     "email-compose",
  //     "email-inbox",
  //     "email-read",
  //     "ecom-product-grid",
  //     "ecom-product-list",
  //     "ecom-product-order",
  //     "ecom-checkout",
  //     "ecom-invoice",
  //     "ecom-customers",
  //     "post-details",
  //     "ecom-product-detail",
  //   ],
  //   email = ["email-compose", "email-inbox", "email-read"],
  //   shop = [
  //     "ecom-product-grid",
  //     "ecom-product-list",
  //     "ecom-product-list",
  //     "ecom-product-order",
  //     "ecom-checkout",
  //     "ecom-invoice",
  //     "ecom-customers",
  //     "ecom-product-detail",
  //   ],
  //   charts = [
  //     "chart-rechart",
  //     "chart-flot",
  //     "chart-chartjs",
  //     //"chart-chartist",
  //     "chart-sparkline",
  //     "chart-apexchart",
  //   ],
  //   bootstrap = [
  //     "ui-accordion",
  //     "ui-badge",
  //     "ui-alert",
  //     "ui-button",
  //     "ui-modal",
  //     "ui-button-group",
  //     "ui-list-group",
  //     "ui-card",
  //     "ui-carousel",
  //     "ui-dropdown",
  //     "ui-popover",
  //     "ui-progressbar",
  //     "ui-tab",
  //     "ui-typography",
  //     "ui-pagination",
  //     "ui-grid",
  //   ],
  //   plugins = [
  //     "uc-select2",
  //     "uc-nestable",
  //     "uc-sweetalert",
  //     "uc-toastr",
  //     "uc-noui-slider",
  //     "map-jqvmap",
  //     "uc-lightgallery",
  //   ],
	// redux = [
  //      "redux-form",
	//    "redux-wizard",    
  //      "todo",
  //   ],
  //   widget = ["widget-basic"],
  //   forms = [
  //     "form-element",
  //     "form-wizard",
  //     "form-ckeditor",
  //     "form-pickers",
  //     "form-validation-jquery",
  //   ],
  //   table = ["table-bootstrap-basic", "table-datatable-basic"],
  //   pages = [
  //     "page-register",
  //     "page-login",
  //     "page-lock-screen",
  //     "page-error-400",
  //     "page-error-403",
  //     "page-error-404",
  //     "page-error-500",
  //     "page-error-503",
  //   ],
  //   error = [
  //     "page-error-400",
  //     "page-error-403",
  //     "page-error-404",
  //     "page-error-500",
  //     "page-error-503",
  //   ];

	
  return (
    <div
      className={`deznav border-right ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
      style={{ position: 'fixed', flexDirection: 'column' }}
    >
      <PerfectScrollbar className="deznav-scroll">         
          <ul className="metismenu" id="menu">
              {getMenuList().map((data, index)=>{
                let menuClass = data.classsChange;
                  if(menuClass === "menu-title"){
                    return(
                        <li className={menuClass}  key={index} >{data.title}</li>
                    )
                  }else{
                    return(				
                      <li className={` ${ state.active === data.title ? 'mm-active' : ''}`}
                        key={index} 
                      >
                        
                        {data.content && data.content.length > 0 ?
                            <Link to={"#"} 
                              className="has-arrow"
                              onClick={() => {handleMenuActive(data.title)}}
                            >								
								                {data.iconStyle}
                                <span className="nav-text">{data.title}</span>
                            </Link>
                        :
                          <NavLink  to={data.to} onClick={closeSidebarOnNavigate}>
                              {data.iconStyle}
                              <span className="nav-text">{data.title}</span>
                          </NavLink>
                        }
                        <Collapse in={state.active === data.title ? true :false}>
                          <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                            {data.content && data.content.map((data,index) => {									
                              return(	
                                  <li key={index}
                                    className={`${ state.activeSubmenu === data.title ? "mm-active" : ""}`}                                    
                                  >
                                    {data.content && data.content.length > 0 ?
                                        <>
                                          <NavLink to={data.to} className={data.hasMenu ? 'has-arrow' : ''}
                                            onClick={() => { handleSubmenuActive(data.title)}}
                                          >
                                            {data.title}
                                          </NavLink>
                                          <Collapse in={state.activeSubmenu === data.title ? true :false}>
                                              <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                                                {data.content && data.content.map((data,index) => {
                                                  return(	
                                                    <>
                                                      <li key={index}>
                                                        <Link className={`${path === data.to ? "mm-active" : ""}`} to={data.to} onClick={closeSidebarOnNavigate}>{data.title}</Link>
                                                      </li>
                                                    </>
                                                  )
                                                })}
                                              </ul>
                                          </Collapse>
                                        </>
                                      :
                                      <Link to={data.to} onClick={closeSidebarOnNavigate}>
                                        {data.title}
                                      </Link>
                                    }
                                    
                                  </li>
                                
                              )
                            })}
                          </ul>
                        </Collapse>
                      </li>	
                    )
                }
              })}          
          </ul>
        </PerfectScrollbar>
      {/* Mobile-only: Change Property/Role and Logout */}
      <div className="sidebar-mobile-actions">
        {diffRoleProperty && !noMoreRole && (
          <button 
            onClick={() => {
              closeSidebarOnNavigate();
              navigate('/change-property');
            }}
            className="sidebar-action-btn sidebar-change-property-btn"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2H2v10h10V2z"></path>
              <path d="M22 12H12v10h10V12z"></path>
              <path d="M22 2H12v10h10V2z"></path>
              <path d="M2 12h10v10H2V12z"></path>
            </svg>
            <span>{diffRoleProperty === 'true' ? 'Change Property/Role' : 'Change Role'}</span>
          </button>
        )}
        <button 
          onClick={() => {
            closeSidebarOnNavigate();
            handleLogout();
          }}
          className="sidebar-action-btn sidebar-logout-btn"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
          <span>Logout</span>
        </button>
      </div>
    </div>
    );
};

export default SideBar;
